import _ from 'lodash'

Promise.allValues = async (object, additions = []) => {
  return _.zipObject(
    [..._.keys(object)],
    (await Promise.all([..._.values(object), ...additions])).slice(0, _.keys(object).length),
  )
}
